import React, { Dispatch, SetStateAction } from 'react'
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { SupplierOperation, OpState } from '../../core/_models'
import { setBulkOrderState, updateBulkOrderState } from '../../core/_requests'
import {
  CustomSelect,
  InputText,
  DatePicker,
  FormActions,
  handleErrors
} from '@/components/form'


interface Props {
  order: SupplierOperation;
  setOrder: Dispatch<SetStateAction<SupplierOperation | undefined>>;
  state?: OpState; // Selected state
  cb?: () => void;
}

const validationSchema = Yup.object().shape({
  state: Yup.string().required('State is required'),
  date: Yup.date().required('Date is required')
})

const StateForm : React.FC<Props> = ({order, setOrder, state, cb}) => {
  const currentState = order?.states?.at(-1)
  const baseStates = order?._config?.states?.slice(2) || []
  const states = state !== undefined  ?
    baseStates :
    baseStates.slice((baseStates.findIndex((s: string) => s === currentState?.state) +1 ))
  const initialValues = {
    state: state?.state || '',
    date: state?.date || '',
    po_number: order?.po_number || '',
    payment_reference: order?.pay_ref || ''
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, {setErrors, resetForm }) => {
        try {
          const submitCb = state ? updateBulkOrderState : setBulkOrderState;
          setOrder(await submitCb(
            order._id,
            values.state,
            new Date(values.date),
            values?.po_number,
            values?.payment_reference,
          ))
          resetForm()
          void(cb && cb())
        } catch (e: unknown) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({ values }) => (
        <Form>
          <Field
            component={CustomSelect}
            disabled={state !== undefined}
            default="Select a state"
            options={states.map((s: string) => {
              return {
                value: s,
                label: s
              }
            })}
            name="state"
            id="state"
            required={true}
          />
          <Field
            component={DatePicker}
            name="date"
            id="date"
            required={true}
            placeholder="Date"
            rawInput={true}
            options={{
              enableTime: true,
              dateFormat: "Y-m-d H:i"
            }}
          />

          {values.state === 'VALIDATED' && (
            <Field
              component={InputText}
              name="po_number"
              id="po_number"
              placeholder="PO Number"
              rawInput={true}
              required={false}
            />
          )}

          {values.state === 'PAID' && (
            <Field
              component={InputText}
              name="payment_reference"
              id="payment_ref"
              placeholder="Payment reference"
              rawInput={true}
              required={false}
            />
          )}

          <Field
            component={FormActions}
            close={() => {
              values = initialValues
              void(cb && cb());
            }}
            position='end'
            padding="pt-3"
          />
        </Form>
      )}
    </Formik>
  )
}

export {StateForm}
